import { ticketGroupTableContants } from '../constants';
import { SELECTED_ALL_VALUES } from '../constants/ticket-group-table.contants';

interface TicketGroupTableStoreState {
  selectedId: { [ticketId: string]: boolean };
  selectedAll: SELECTED_ALL_VALUES;
}

const initialState: TicketGroupTableStoreState = {
  selectedId: {},
  selectedAll: 'NONE',
};
export const ticketGroupTable = (
  state = initialState,
  action: {
    type: string;
    payload?: { id?: string; value?: boolean; ids?: string[] };
  },
) => {
  switch (action.type) {
    case ticketGroupTableContants.SET_SELECTED_ID:
      if (!action.payload?.id) {
        throw Error(`payload.id is missing`);
      }
      if (action.payload?.value === undefined) {
        throw Error(`payload.value cannot be undefined`);
      }
      return {
        ...state,
        selectedId: {
          ...state.selectedId,
          [action.payload.id]: action.payload.value,
        },
      };
    case ticketGroupTableContants.CLEAR_SELECTED_ID:
      return {
        ...state,
        selectedId: {},
      };
    case ticketGroupTableContants.BULK_SET_SELECTED_ID:
      if (!action.payload?.ids) {
        throw Error(`payload.ids is missing`);
      }
      if (action.payload?.value === undefined) {
        throw Error(`payload.value cannot be undefined`);
      }
      return {
        ...state,
        selectedId: action.payload.ids?.reduce(
          (acc, id) => ({
            ...acc,
            [id]: action.payload?.value || false,
          }),
          state.selectedId,
        ),
      };
    case ticketGroupTableContants.SET_SELECTED_ALL:
      if (action.payload?.value === undefined) {
        throw Error(`payload.value cannot be undefined`);
      }
      return {
        ...state,
        selectedAll: action.payload?.value,
      };
    case ticketGroupTableContants.RESET_STATE:
      return initialState;
    default:
      return state;
  }
};
